import GitHubIcon from '../../assets/mediaIcons/GitHubIcon.png';
import LinkedInIcon from '../../assets/mediaIcons/LinkedInIcon.png';
import GmailIcon from '../../assets/mediaIcons/GmailIcon.png';

let contactData = [
    {
      id: 1,
      name: "GitHub",
      link: "https://github.com/ShaHos348",
      image: GitHubIcon,
    },
    {
      id: 2,
      name: "LinkedIn",
      link: "https://www.linkedin.com/in/shahbin-hossain/",
      image: LinkedInIcon,
    },
    {
      id: 3,
      name: "Gmail",
      link: "mailto:shahbinschool@gmail.com",
      image: GmailIcon,
    }
  ];
  
  export default contactData;